import { MessageSquare } from 'lucide-react';
import { CalloutList } from '../shared/GroupedCallout';
import { SectionHeader, EmptyState } from '../shared/InfoGrid';
import { getRemarkBorderColor, isRemarkFaded } from '../utils/statusCodes';
import type { Remark } from '../utils/types';

interface RemarksTabProps {
  remarks: Remark[];
}

export function RemarksTab({ remarks }: RemarksTabProps) {
  // Sort remarks by OT number
  const sortedRemarks = [...remarks].sort((a, b) => {
    const numA = parseInt(a.id.replace(/\D/g, '')) || 0;
    const numB = parseInt(b.id.replace(/\D/g, '')) || 0;
    return numA - numB;
  });

  if (!remarks || remarks.length === 0) {
    return (
      <EmptyState
        icon={<MessageSquare className="h-6 w-6" />}
        title="No remarks"
        description="This booking doesn't contain any remarks"
      />
    );
  }

  return (
    <div>
      <SectionHeader
        title="Remarks"
        icon={<MessageSquare className="h-5 w-5" />}
        count={remarks.length}
      />

      <CalloutList
        items={sortedRemarks}
        renderContent={(remark) => remark.freetext}
        getBorderColor={(remark) => `border-l-${getRemarkBorderColor(remark.remarkType)}`}
        isFaded={(remark) => isRemarkFaded(remark.freetext)}
      />
    </div>
  );
}
